import styles from './index.module.scss';
import React from 'react';
import classNames from 'classnames';

interface SpaceWrapperProps {
    className?: string;
    children?: React.ReactNode;
    padding?: boolean;
}

export function SpaceWrapper({
    children,
    padding,
    className,
}: SpaceWrapperProps) {
    return (
        <div
            className={classNames(styles.root, className, {
                [styles.padding]: padding,
            })}>
            {children}
        </div>
    );
}
